import { connect } from 'react-redux';
import { actions } from '@/state/filterActions';

import { fetchHotelResults } from '@/state/hotelResultActions';

import { EmptyWarning, type EmptyWarningProps } from './EmptyWarning';

const mapStateToProps = (): Pick<EmptyWarningProps, 'id'> => ({
    id: 'hotel',
});

const mapDispatchToProps = { resetFilters: actions.resetHotelFilters, triggerFetch: fetchHotelResults };

export default connect(mapStateToProps, mapDispatchToProps)(EmptyWarning);
